import { render, staticRenderFns } from "./UnlockRequestModal.vue?vue&type=template&id=11e8a923&scoped=true&"
import script from "./UnlockRequestModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UnlockRequestModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e8a923",
  null
  
)

export default component.exports